import { useAppSelector } from '@redux/hooks';
import { getBasketData } from '@entities/Basket';
import { BasketCartProduct } from '../BasketCartProduct';

import styles from './BasketListProduct.module.scss';

export const BasketListProduct = () => {
  const basket = useAppSelector(getBasketData);
  return (
    <div className={styles.Container}>{basket?.items?.map((item, index) => <BasketCartProduct index={index} key={item?.id} {...item} />)}</div>
  );
};
